import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import RedesignedHero from "@/components/redesigned/hero";
import { SidebarProvider } from "@/components/ui/sidebar";
import { toast } from "@/hooks/ui/use-toast";

// Inner component (provided by GlobalLayout)
const IndexContent = () => {
  const navigate = useNavigate();

  // Handle auth from URL hash (recovery links and errors)
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.substring(1));
    const error = params.get('error');
    const errorCode = params.get('error_code');
    const errorDescription = params.get('error_description');
    const isRecoveryType = params.get('type') === 'recovery';

    // Forward valid recovery links to sign-in (preserve hash for processing)
    if (isRecoveryType) {
      navigate('/auth' + window.location.hash, { replace: true });
      return;
    }

    // Handle auth errors (e.g., expired password reset links)
    if (error) {
      const message = errorDescription
        ? decodeURIComponent(errorDescription.replace(/\+/g, ' '))
        : 'An authentication error occurred';

      toast.error("Authentication Error", {
        description: errorCode === 'otp_expired'
          ? "The email link has expired. Please request a new one."
          : message,
      });

      // Clean up the URL hash - stay on landing page (don't navigate away)
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, [navigate]);

  return (
    <div className="min-h-screen w-full flex flex-col bg-background overflow-x-clip">
      <Navbar enableScrollHide />
      <main className="flex-grow">
        <RedesignedHero />
      </main>
      <Footer cta={false} />
    </div>
  );
};

// AIViewProvider is provided by GlobalLayout, no need to wrap here
const Index = () => {
  return (
    <SidebarProvider>
      <IndexContent />
    </SidebarProvider>
  );
};

export default Index;
